import { FormattedMessage } from "react-intl";
import AnimatedModal from "components/AnimateModal/AnimateModal";
import { FilePreviewCrossIcon } from "pages/Workspaces/components/icons/CrossIcon";
import classNames from "classnames";
import { useSelector } from "redux/hooks";
import styles from "./Incompatiblemodal.module.scss";
import { Notifications } from "pages/Workspaces/components/Notifications/Notifications";
import links from "core/links";

interface IProp {
  openInCompatibleModel: boolean;
  onClose: () => void;
}
export const InCompatibleModal = ({ openInCompatibleModel, onClose }: IProp) => {
  const { theme } = useSelector((state) => state.authReducer);
   const {fileExtension} = useSelector((state) => state.chatReducer);
  return (
    <>
      <AnimatedModal
        compatibility={true}
        isOpen={openInCompatibleModel}
        onClose={() => onClose?.()}
      >
        <div className="flex items-center justify-between">
          <div
            className={classNames("font-inter", styles.modalHead, {
              [styles.light]: theme === "light",
              [styles.dark]: theme === "dark",
            })}
          >
            <FormattedMessage id="incompatible.model.head" />
          </div>
          <div onClick={onClose} className="cursor-pointer"
          >
            <FilePreviewCrossIcon />
          </div>
        </div>

        <div className="font-inter mt-[20px]">
          <Notifications incompatible={true}
            notificationIds={[
              "incompatible.model.point1",
              "incompatible.model.point2",
            ]}
            headingId="incompatible.model.info"
            subHeading="incompatible.model.pointhead"
            values={{ extension: fileExtension || 'xyz' }}
          />
        </div>
        <div className={`font-inter mt-[18px] ${styles.modalNotes}`}>
          <FormattedMessage id="incompatible.model.notes" />
        </div>
        <a
          href={links.ShareFeedback}
          target="_blank"
          rel="noreferrer"
          className="no-underline"
        >
          <div className="flex justify-end mt-[12px]">
            <button
              className={styles.continueButton}
            // Add your continue handler here
            >
              <span className={classNames("font-inter", styles.continue)}>
                {" "}
                <FormattedMessage id="feedback.heading" />{" "}
              </span>
            </button>
          </div>
        </a>
      </AnimatedModal>
    </>
  );
};
